import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Icon } from '../Icon/Icon.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import 'react';

const Styles = labelStyles("TableHeadSortButton", {
  root: css`
    display: flex;
    align-items: center;
    gap: var(--zds-space-8);
    color: ${Colors.TextDefault};
    ${Typography.SmallPrint2};
  `
});
const TableHeadSortButton = (props) => {
  return jsx(
    "button",
    { type: "button", css: Styles.root, onClick: props.onClick, "data-zds": true },
    props.children,
    jsx(Icon, { color: "GrayWarm6", name: "arrowDropdown", size: 16 })
  );
};

export { TableHeadSortButton };
//# sourceMappingURL=TableHeadSortButton.es.js.map
